export default __webpack_public_path__ + "static/media/TiktokAppIcon.8e90d6ce.svg";